import { IconProps } from 'types/icon.type'

export const TickThinIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Tick thin icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.741 5.43942C21.0595 5.71458 21.0882 6.18863 20.8052 6.49824L9.83531 18.4982C9.68894 18.6584 9.47912 18.75 9.25879 18.75C9.03845 18.75 8.82861 18.6584 8.6822 18.4984L3.19494 12.4984C2.91184 12.1888 2.94045 11.7148 3.25884 11.4395C3.57724 11.1643 4.06484 11.1921 4.34794 11.5017L9.25858 16.8712L19.652 5.50177C19.935 5.19217 20.4226 5.16425 20.741 5.43942Z"
        fill="currentColor"
      />
    </svg>
  )
}
